import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

// Format a UTC ISO string as "DD MMM YYYY h:mm a" in America/New_York (EST/EDT).
// TODO: replace hardcoded timezone with a user-configurable preference.
export function formatEstTimestamp(value: string | null | undefined): string {
  if (!value) return '-';
  const d = dayjs(value).tz('America/New_York');
  return d.isValid() ? d.format('DD MMM YYYY h:mm a') : '-';
}

// Format a date input (ISO string, Date, or epoch) as MM/DD/YYYY using UTC
export function formatDate(input: string | number | Date | null | undefined): string {
  if (!input) return '-';
  try {
    let d: Date;
    if (input instanceof Date) {
      d = input;
    } else if (typeof input === 'number') {
      d = new Date(input);
    } else if (typeof input === 'string') {
      const msMatch = input.match(/^\/Date\((\d+)\)\/$/);
      d = msMatch ? new Date(Number(msMatch[1])) : new Date(input);
    } else {
      return '-';
    }
    if (Number.isNaN(d.getTime())) return '-';
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const yyyy = d.getUTCFullYear();
    return `${mm}/${dd}/${yyyy}`;
  } catch (_) {
    return '-';
  }
}